/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_BewerbungslinkInputs */

const de__field_bewerbungslink = /** @type {(inputs: _Field_BewerbungslinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bewerbungslink`)
};

/**

* @param {_Field_BewerbungslinkInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_bewerbungslink = /** @type {((inputs?: _Field_BewerbungslinkInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_BewerbungslinkInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_bewerbungslink(inputs)
});